<template>
  <div class="theme-picker" :class="`theme-picker--${variant}`">
    <template v-if="variant === 'dropdown'">
      <b-dropdown-item
        v-for="option in options"
        :key="option.value"
        :active="option.value === pref"
        class="theme-picker__dropdown-item"
        @click="choose(option.value)">
        <i :class="option.icon" class="mr-2"></i>
        {{ option.label }}
        <i v-if="option.value === pref" class="ri-check-line theme-picker__check"></i>
      </b-dropdown-item>
    </template>
    <template v-else>
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="theme-picker__list-item"
        :class="{ 'is-active': option.value === pref }"
        @click="choose(option.value)">
        <i :class="option.icon"></i>
        <span>{{ option.label }}</span>
        <i v-if="option.value === pref" class="ri-check-line theme-picker__check"></i>
      </button>
    </template>
  </div>
</template>

<script>
// tiga pilihan tema, dipakai ulang di dropdown navbar & sheet More
const THEME_OPTIONS = [
  { value: 'light', label: 'Light', icon: 'ri-sun-line' },
  { value: 'dark', label: 'Dark', icon: 'ri-moon-line' },
  { value: 'system', label: 'System', icon: 'ri-computer-line' },
];

export default {
  name: 'ThemePicker',
  props: {
    variant: {
      type: String,
      default: 'dropdown',
      validator: (value) => ['dropdown', 'list'].includes(value),
    },
  },
  data() {
    return { options: THEME_OPTIONS };
  },
  computed: {
    pref() {
      return this.$store.state.theme.pref;
    },
  },
  methods: {
    choose(pref) {
      this.$store.dispatch('theme/setPref', pref);
    },
  },
};
</script>

<style scoped>
.theme-picker__check {
  margin-left: auto;
  color: var(--mz-primary-ink);
}

.theme-picker--list {
  display: flex;
  flex-direction: column;
}

.theme-picker__list-item {
  display: flex;
  align-items: center;
  gap: var(--mz-space-3);
  min-height: 48px;
  padding: 0 var(--mz-space-4);
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--mz-text);
  font-size: var(--mz-fs-base);
  text-align: left;
}

.theme-picker__list-item.is-active {
  color: var(--mz-primary-ink);
  font-weight: var(--mz-fw-label);
}
</style>
